import { motion } from 'framer-motion';

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.15 }
  }
};

export default function LegalPage() {
  return (
    <div className="page-wrapper" data-testid="legal-page">
      {/* Hero Section */}
      <section className="hero-section relative min-h-[40vh] flex items-center overflow-hidden" data-testid="legal-hero">
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://customer-assets.emergentagent.com/job_cf0aab81-969a-4e9c-9793-f40790513670/artifacts/ozk0drws_IMAGE_PAGE_GARDE_CONSOLIDATION.png')`,
            opacity: 0.7
          }}
        />
        <div className="hero-overlay" />
        <div className="hero-content w-full pt-32 pb-16">
          <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
            <motion.div
              variants={staggerContainer}
              initial="hidden"
              animate="visible"
              className="max-w-3xl"
            >
              <motion.p
                variants={fadeUp}
                transition={{ duration: 0.8 }}
                className="text-[#C5A059] text-xs tracking-[0.3em] uppercase mb-4"
              >
                Informations légales
              </motion.p>
              <motion.h1
                variants={fadeUp}
                transition={{ duration: 0.8, delay: 0.1 }}
                className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#FDFBF7] font-medium tracking-tight leading-tight mb-6"
              >
                Mentions légales
              </motion.h1>
              <motion.div 
                variants={fadeUp}
                transition={{ duration: 0.8, delay: 0.2 }}
                className="gold-line mb-8"
              />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 md:py-24 bg-[#FDFBF7]" data-testid="legal-content">
        <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-24">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="space-y-12"
          >
            {/* Section 1 - Éditeur du site */}
            <div className="space-y-4">
              <h2 className="font-serif text-2xl md:text-3xl text-[#0B1221] font-medium">
                1. Éditeur du site
              </h2>
              <div className="space-y-2 text-[#64748B] leading-relaxed">
                <p><span className="text-[#0B1221] font-medium">Dénomination sociale / Raison sociale :</span> CLICQCONSULT</p>
                <p><span className="text-[#0B1221] font-medium">Forme juridique :</span> SRL</p>
                <p><span className="text-[#0B1221] font-medium">Siège social :</span> 12, Avenue de Maire 7500 TOURNAI (Belgique)</p>
                <p><span className="text-[#0B1221] font-medium">Numéro d'entreprise (BCE) :</span> 0544.664.797</p>
                <p><span className="text-[#0B1221] font-medium">Numéro de TVA :</span> TVA BE544664797</p>
                <p><span className="text-[#0B1221] font-medium">E-mail :</span> <a href="mailto:mac@clicqconsult.com" className="text-[#C5A059] hover:underline">mac@clicqconsult.com</a></p>
                <p><span className="text-[#0B1221] font-medium">Téléphone :</span> <a href="tel:+3269600224" className="text-[#C5A059] hover:underline">+32 69/60.02.24</a></p>
                <p><span className="text-[#0B1221] font-medium">Responsable de la publication :</span> Mathieu CLICQ</p>
              </div>
            </div>

            {/* Ligne de séparation */}
            <div className="w-16 h-px bg-[#C5A059]/30" />

            {/* Section 2 - Hébergement */}
            <div className="space-y-4">
              <h2 className="font-serif text-2xl md:text-3xl text-[#0B1221] font-medium">
                2. Hébergement
              </h2>
              <div className="space-y-2 text-[#64748B] leading-relaxed">
                <p><span className="text-[#0B1221] font-medium">Nom de l'hébergeur :</span> NUXIT</p>
                <p><span className="text-[#0B1221] font-medium">Adresse de l'hébergeur :</span> Groupe CELESTE - Nuxit - 20 rue Albert Einstein - 77420 Champs sur Marne (France)</p>
                <p><span className="text-[#0B1221] font-medium">Site web :</span> <a href="https://www.nuxit.com" target="_blank" rel="noopener noreferrer" className="text-[#C5A059] hover:underline">https://www.nuxit.com</a></p>
              </div>
            </div>

            {/* Ligne de séparation */}
            <div className="w-16 h-px bg-[#C5A059]/30" />

            {/* Section 3 - Propriété intellectuelle */}
            <div className="space-y-4">
              <h2 className="font-serif text-2xl md:text-3xl text-[#0B1221] font-medium">
                3. Propriété intellectuelle
              </h2>
              <p className="text-[#64748B] leading-relaxed text-justify">
                Tous les éléments du site, y compris les textes, graphismes, logos, sont la propriété de la société, sauf mention contraire, et sont protégés par le droit d'auteur.
              </p>
            </div>

            {/* Ligne de séparation */}
            <div className="w-16 h-px bg-[#C5A059]/30" />

            {/* Section 4 - Données personnelles */}
            <div className="space-y-4">
              <h2 className="font-serif text-2xl md:text-3xl text-[#0B1221] font-medium">
                4. Données personnelles (RGPD) et cookies
              </h2>
              <p className="text-[#64748B] leading-relaxed text-justify">
                Conformément à la législation sur la protection des données, vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour plus d'informations, consultez notre Politique de confidentialité.
              </p>
            </div>

            {/* Ligne de séparation */}
            <div className="w-16 h-px bg-[#C5A059]/30" />

            {/* Section 5 - Droit applicable */}
            <div className="space-y-4">
              <h2 className="font-serif text-2xl md:text-3xl text-[#0B1221] font-medium">
                5. Droit applicable
              </h2>
              <p className="text-[#64748B] leading-relaxed text-justify">
                Les présentes mentions légales sont régies par le droit belge. Les tribunaux de Tournai sont compétents en cas de litige.
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
